<template>
  <div>
    <el-dialog title="选择图片" :visible.sync="dialogVisible" @open="handleOpen" @close="handleClose">
      <div class="imageSelect_box">
        <div class="tree_box">
          <el-tree :data="treeData" :props="treeDefaultProps" @node-click="handleNodeClick"></el-tree>
        </div>
        <div class="right_box" v-if="showSelfButton">
          <div style="display: flex;justify-content: center;height: 40px;">
            <el-input style="width: 60%;margin-right: 10px"
                      placeholder="输入自定义图片名称"
                      v-model="searchImgText"
                      clearable>
            </el-input>
            <el-button icon="el-icon-search" circle @click="initSelfImgList"></el-button>
            <el-button type="success" icon="el-icon-upload" circle @click="uploadImgDialogVisible=true"></el-button>
          </div>
          <div class="image_box_2">
            <div class="image_item" v-for="(elem, index) in imgList" :key="index">
              <img class="image_item_img" :src="elem.prefix+elem.url+elem.suffix" @click="handleImageSelection(index)"/>
              <div style="display: flex;align-items: center;margin-top: 3px;">
                <div class="image_item_text">{{elem.name}}</div>
                <el-button type='danger' size='mini' icon="el-icon-delete" circle @click="deleteImgIndex=elem.id;deleteSelfImgVisible=true;"></el-button>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="right_box">
          <div class="image_box">
            <div class="image_item" v-for="(elem, index) in imgList" :key="index">
              <img class="image_item_img" :src="elem.prefix+elem.url+elem.suffix" @click="handleImageSelection(index)"/>
              <div class="image_item_text">{{elem.name}}</div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
        title="提示"
        :visible.sync="deleteSelfImgVisible"
        width="30%"
    >
      <span>确定删除该自定义图片？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteSelfImgVisible=false;">取 消</el-button>
        <el-button type="primary" @click="deleteSelfImg">确 定</el-button>
     </span>
    </el-dialog>
    <el-dialog title="上传自定义图片" :visible.sync="uploadImgDialogVisible">
      <el-form>
        <el-form-item label="图片名称" label-width="120px">
          <el-input v-model="uploadImgName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="上传图片" label-width="120px">
          <el-upload
              class="avatar-uploader"
              :action="uploadAPI"
              :show-file-list="false"
              :data="uploadImgData"
              :on-success="handleUploadImageSuccess"
          >
            <img v-if="uploadImgUrl" :src="imgPrefix+uploadImgUrl+companySuffix" class="avatar">
            <div v-else class="avatar-uploader-icon">
              <i class="el-icon-plus"></i>
            </div>

          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="uploadImgUrl='';uploadImgDialogVisible=false;">取 消</el-button>
        <el-button type="primary" @click="handleUploadImg();">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import pictureKindList from "@/components/ProductComponents/Config/pictureKindList";
import API from "../../../config/api";
import DOMAIN_PREFIX from "../../../config/domainPrefix";
const AVATAR_PREFIX = DOMAIN_PREFIX.AVATAR_PREFIX
const IMG_PREFIX = DOMAIN_PREFIX.IMG_PREFIX
export default {
  name: "ImageSelector",
  props: ['companyId','projectId'],
  data() {
    return {
      dialogVisible: false,
      showSelfButton: false,//是否展示 上传图片的一栏按钮
      //静态图片
      pictureKindList: pictureKindList,
      pictureKindId: 0,
      pictureKindId0: 0,
      treeData: [],//树形结构数据
      treeDefaultProps: {
        children: 'children',
        label: 'label'
      },
      imgPrefix: AVATAR_PREFIX,
      imgUrl: "",
      searchImgText: "",//搜索图片的关键词
      selfImgList: [],
      imgList: [],//右侧展示的图片列表

      //上传图片的表单
      uploadAPI: API.fileUpload,
      uploadImgUrl:"",
      uploadImgDialogVisible: false,
      uploadImgName: "",

      //删除图片
      deleteSelfImgVisible: false,
      deleteImgIndex: 0,

      //防止一直操作，限流变量：用户点击确定后该值设为true，1s后再设为false
      clickFlag: false,
    }
  },
  mounted() {
    //初始化遍历pictureKindList，初始化树结构
    this.treeData = [];
    this.treeData.push({
      label: '用户图片',
      type:"self"
    });
    for(let i=0;i<pictureKindList.length;i++){
      let obj = pictureKindList[i];
      let pack = {label: obj.name, children: [], id: obj.id};
      for(let j=0;j<obj.type.length;j++){
        pack.children.push({label: obj.type[j].name, type:"static", id: obj.id, id0: obj.type[j].id0})
      }
      this.treeData.push(pack);
    }
    this.initSelfImgList();
  },
  computed:{
    uploadImgData(){
      return {
        flag:1,
        userid: window.localStorage.getItem("userid"),
        token: window.localStorage.getItem("token"),
        companyId: this.companyId
      }
    },
  },
  methods:{
    openDialog(){
      this.dialogVisible = true;
    },
    handleImageSelection(index){
      this.imgUrl = this.imgList[index].prefix + this.imgList[index].url;
      this.returnImageUrl()
    },
    //将选择的图片url传递给父组件
    returnImageUrl(){
      if(this.clickFlag) {
        //防止用户误操作
        return;
      }
      this.clickFlag = true;
      setTimeout(()=>{
        this.clickFlag = false;
      },1000);
      this.dialogVisible = false;
      //console.log(this.imgUrl)
      this.$emit("returnImageUrl", this.imgUrl);
    },
    handleNodeClick(data){
      console.log(data);
      if(data.type === "static"){
        this.imgList = [];
        this.showSelfButton = false;
        let obj = pictureKindList[data.id].type[data.id0].pictureList;
        for(let i = 0;i < obj.length; i++){
          this.imgList.push({
            url: obj[i].url,
            name: obj[i].name,
            prefix: IMG_PREFIX,
            suffix: "",
          })
        }

      }else if(data.type==='self'){
        this.showSelfButton = true;
        this.imgList = this.selfImgList;
      }
    },
    //初始化自定义图片
    initSelfImgList(){
      let data = {
        companyId: this.companyId,
        imgName: this.searchImgText,
      }
      this.$axiosRequest({
        url: API.getUserUploadImgList,
        method: 'POST',
        data: data,
        success: res => {
          //console.log("res:",res)
          let tmpList = res.data["imgList"];
          this.selfImgList = []
          for (let i = 0; i < tmpList.length; i++){
            this.selfImgList.push({
              name: tmpList[i].imgName,
              prefix: AVATAR_PREFIX,
              suffix: this.companySuffix,
              url: tmpList[i].imgUrl,
              id: tmpList[i].id,
            })
          }
          if(this.showSelfButton){
            this.imgList = this.selfImgList;
          }
        }
      })
    },
    handleUploadImageSuccess(e){
      this.uploadImgUrl = e;
    },
    handleUploadImg(){
      if(!this.uploadImgName){
        this.$message({
          message: "请输入图片名",
          type: "warning"
        })
        return;
      }
      if(!this.uploadImgUrl){
        this.$message({
          message: "请上传图片",
          type: "warning"
        })
        return;
      }
      let data = {
        companyId: this.companyId,
        projectId: this.projectId,
        imgUrl: this.uploadImgUrl,
        imgName: this.uploadImgName,
        description: " ",
      }
      this.$axiosRequest({
        url: API.addUserUploadImg,
        method: 'POST',
        data: data,
        header: API.header,
        success: res => {
          if (res.data > 0) {
            this.$message({
              message: "上传成功",
              type: "success"
            })
            this.uploadImgDialogVisible = false;
            this.uploadImgUrl = "";
            this.uploadImgName = "";
            this.initSelfImgList();
          } else if (res.data == 0) {
            this.$message({
              message: "图片名重复",
              type: "warning"
            })
          } else if (res.data == -2) {
            this.$message({
              message: "参数错误",
              type: "warning"
            })
          }
        }
      })
    },
    //删除图片
    deleteSelfImg(){
      let data = {
        companyId: this.companyId,
        id: this.deleteImgIndex,
      }
      console.log(data);
      this.$axiosRequest({
        url: API.deleteUserUploadImg,
        method: 'POST',
        data: data,
        header: API.header,
        success: res => {
          console.log(res.data)
          if (res.data == 0) {
            this.$message({
              message: '删除成功',
              type: 'success',
            })
            this.deleteSelfImgVisible = false;
            this.initSelfImgList()
          } else if (res.data == -1 || res.data == -2) {
            this.$message({
              message: '删除失败',
              type: 'warning',
            })
          }
        }
      })
    },
    handleOpen(){
      this.$bus.$emit("handle-stop-wrapper-click-listening");
    },
    handleClose(){
      this.$bus.$emit("handle-continue-wrapper-click-listening");
    }
  }
}
</script>

<style>
.imageSelect_box{
  display: flex;
  height: 800px;
}
.tree_box{
  width: 300px;
}
.right_box{
  width: 790px;
  height: 800px;
}
.image_box{
  height: 800px;
  display: grid;
  grid-template-columns: repeat(auto-fill,100px);
  grid-template-rows: repeat(auto-fill,120px);
  overflow-y: scroll;
}
.image_box_2{
  height: 760px;
  display: grid;
  grid-template-columns: repeat(auto-fill,100px);
  grid-template-rows: repeat(auto-fill,120px);
  overflow-y: scroll;
}
.image_item{
  margin: 10px;
  height: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.image_item_img{
  width: 80px;
  height: 80px;
}
.image_item_text{
  font-size: 16px;
  font-weight: bold;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>